import { api, authHeader } from "../configs/axiosConfigs";

const PackagesApiService = {
  // دریافت لیست پکیج‌های فعال
  getActivePackages: async () => {
    const response = await api.request({
      url: "/api/Packages/GetActivePackages",
      method: "GET",
      params: { includeEquipments: true }, // درخواست دریافت تجهیزات
    });
    return response.data;
  },

  // دریافت جزئیات پکیج
  getPackageDetails: async (id) => {
    const response = await api.request({
      url: `/api/Packages/GetPackageDetails/${id}`,
      method: "GET",
    });
    return response.data;
  },

  // دریافت پکیج‌های پیمانکار
  getContractorPackages: async (contractorId) => {
    const response = await api.request({
      url: `/api/Packages/GetContractorPackages/${contractorId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  // جستجوی پکیج‌ها
  searchPackages: async (params) => {
    const response = await api.request({
      url: "/api/Packages/SearchPackages",
      method: "GET",
      params: { ...params, includeEquipments: true }, // درخواست دریافت تجهیزات
    });
    return response.data;
  },

  // مقایسه پکیج‌ها
  comparePackages: async (packageIds) => {
    const response = await api.request({
      url: "/api/Packages/ComparePackages",
      method: "POST",
      headers: authHeader(),
      data: { packageIds },
    });
    return response.data;
  },

  // دریافت پکیج‌های قابل انتخاب برای یک درخواست
  getPackagesForRequest: async (requestId) => {
    console.log("=== PackagesApiService.getPackagesForRequest ===");
    console.log("requestId:", requestId);
    console.log("URL:", `/api/Packages/GetPackagesForRequest/${requestId}`);

    const response = await api.request({
      url: `/api/Packages/GetPackagesForRequest/${requestId}`,
      method: "GET",
      headers: authHeader(),
      params: { includeEquipments: true }, // درخواست دریافت تجهیزات
    });

    console.log("Response:", response);
    return response.data;
  },

  // ثبت انتخاب پکیج برای درخواست و ایجاد قرارداد
  selectPackageForRequest: async (requestId, packageId, contractorId) => {
    const response = await api.request({
      url: "/api/Packages/SelectPackageForRequest",
      method: "POST",
      headers: authHeader(),
      data: {
        requestId,
        packageId,
        contractorId,
      },
    });
    return response.data;
  },
};

export default PackagesApiService;
